import { encode } from "uqr";

// One SVG path for the dark modules, so the code prints crisply at any size.
export function qrPath(text: string): { path: string; size: number } {
  const { data, size } = encode(text, { border: 2, ecc: "M" });
  const parts: string[] = [];
  data.forEach((row, y) =>
    row.forEach((dark, x) => {
      if (dark) parts.push(`M${x} ${y}h1v1h-1z`);
    }),
  );
  return { path: parts.join(""), size };
}

// The address a phone opens when it scans the label.
export function assetQrUrl(
  qrUrl: string | null | undefined,
  token: string | undefined,
): string | null {
  if (qrUrl) return qrUrl;
  return token ? `https://safeplate.nz/a/${encodeURIComponent(token)}` : null;
}

// The printable label for one asset; it gets a code when first opened.
export function assetLabelPath(assetId: string): string {
  return `/labels/assets/${encodeURIComponent(assetId)}`;
}

// Every fridge's label at a location, for printing in one go.
export function locationLabelsPath(locationId: string): string {
  return `/labels/assets?location_id=${encodeURIComponent(locationId)}`;
}
